import { create } from 'zustand';
import { farmbaseApi } from '../services/api';
import type { Farmbase } from '../types/domain';

interface FarmbaseState {
  farmbases: Farmbase[];
  selectedFarmbaseId: string | null;
  isLoading: boolean;
  error: string | null;

  fetchFarmbases: (unitId?: string) => Promise<void>;
  getFarmbasesForUnit: (unitId: string) => Farmbase[];
  setSelectedFarmbaseId: (id: string | null) => void;
}

export const useFarmbaseStore = create<FarmbaseState>((set, get) => ({
  farmbases: [],
  selectedFarmbaseId: null,
  isLoading: false,
  error: null,

  fetchFarmbases: async (unitId?: string) => {
    set({ isLoading: true, error: null });
    try {
      const response = await farmbaseApi.getAll(unitId ? { unitId } : undefined);
      set({ farmbases: response.data.farmbases || [], isLoading: false });
    } catch (error: any) {
      set({
        error: error.response?.data?.error || 'Failed to fetch farmbases',
        isLoading: false,
      });
    }
  },

  // Farmbase is a sub-scope inside a unit — selecting a unit filters its farmbases.
  getFarmbasesForUnit: (unitId: string) => get().farmbases.filter((f) => f.unitId === unitId),

  setSelectedFarmbaseId: (id: string | null) => set({ selectedFarmbaseId: id }),
}));
